import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgProgressModule } from "@ngx-progressbar/core";
import { SocketIoConfig, SocketIoModule } from "ngx-socket-io";
import { CamerallaLayoutComponent } from "./cameralla-layout.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
// import { NotificationComponent } from "./notification/notification.component";
import { SharedPipeModule } from "../../pipes/shared.pipe.module";
// import { NotificationListComponent } from "./notification/component/notification-list.component/notification-list.component";
// import { MailPopupComponent } from "../../../modules/mail/components/mail-popup/mail-popup.component";
import { FormsModule } from "@angular/forms";
import { environment } from "../../../../environments/environment";
import { AuthModule } from "../../../core/modules/auth/auth.module";
// import { TutorialComponent } from "./tutorial/tutorial.component";
// import { InboxComponent } from "./inbox/inbox.component";
// import { InboxListComponent } from "./inbox/component/inbox-list.component/inbox-list.component";
// import { PartnerMenuComponent } from "./partner-menu/partner-menu.component";

const config: SocketIoConfig = { url: environment.socket, options: {} };

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedPipeModule,
    AuthModule,
    FormsModule,
    NgProgressModule,
    SocketIoModule.forRoot(config),
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    CamerallaLayoutComponent,
    // NotificationComponent,
    // NotificationListComponent,
    // MailPopupComponent,
    // TutorialComponent,
    // PartnerMenuComponent,
    // InboxComponent,
    // InboxListComponent,
  ],
  entryComponents: [
    // NotificationListComponent,
    // MailPopupComponent,
    // InboxComponent,
    // InboxListComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    CamerallaLayoutComponent,
    // NotificationComponent,
    // InboxComponent,
    // NotificationListComponent,
    // CamerallaLayoutComponent,
    // MailPopupComponent,
  ],
})
export class CamerallaLayoutModule {}
